<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light" @keyup.enter="load">
                <b-row class="my-3 align-items-center">
                    <b-col cols="4">
                        <LgFinderPageEmpresa :prefix="[prefix + title]" v-model="empresa" label="Participantes:"
                            @input="handleEmpresa" />

                    </b-col>

                    <b-col cols="4">
                        <LgFinderPageProduto :prefix="prefix + title + ' > '" v-model="produto" label="Produto:"
                            @onselect="handleProduto" />

                    </b-col>

                    <b-col cols="4">
                        <LgFinderPageStatus :tipo="71" :prefix="[prefix + title]" v-model="status" label="Status:"
                            @input="handleStatus" />

                    </b-col>
                    <b-col cols='4' class="mt-2">
                        <b-row class="align-items-center">
                            <b-col>
                                <lg-form-input v-model="pesquisa" label=" "></lg-form-input>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols='2' class='d-flex justify-content-center align-items-center'>
                        <b-button v-b-tooltip.hover.top="'Localizar'" id="localizar" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                        </b-button>
                        <b-button id="Limpar" v-b-tooltip.hover.top="'Limpar'" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill variant="primary" @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                        </b-button>
                        <b-button v-b-tooltip.hover.top="'Adicionar nova...'" id="novo" class="mr-2 my-2" size="sm"
                            style="height: 20px" pill @click="showModalNovaAta" variant="primary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                        </b-button>
                    </b-col>
                </b-row>
            </b-card>
            <b-card bg-variant="light" class="mt-3">
                <b-table @row-dblclicked="clickRow" responsive class="mt-2" small :busy="busy" :items="records"
                    :fields="fields" hover show-empty>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template v-slot:cell(dataCriacao)="data">
                        {{ formatDate(data.item.dataCriacao) }}

                    </template>

                    <template v-slot:cell(dataInicial)="data">
                        {{ formatDate(data.item.dataInicial) }} - {{ formatDate(data.item.dataFinal) }}

                    </template>
                    <template v-slot:cell(status)="data">
                        <b-badge :variant="badgeVariant(data.item.idStatus)" class="badge">
                            {{ formatSituacao(data.item.idStatus) }}
                        </b-badge>
                    </template>


                    <template v-slot:cell(actions)="data">
                        <b-row class='justify-content-end pr-4'>

                            <b-button v-if="data.item.idStatus == 270" class="my-2 mx-1" size="sm" pill
                                variant="primary" @click="abrirModalConsultarSolicitacaoAlteracaoValor(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Solicitar Alteração de Valor'"
                                    icon="currency-exchange" />
                            </b-button>


                            <b-button v-if="data.item.idStatus == 270 && data.item.idOrgaoGerenciador != departamento"
                                class="my-2 mx-1" size="sm" pill variant="primary" @click="abrirRequisicoes(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Criar Requisição de Compra'" icon="file-earmark-text" />
                            </b-button>



                            <b-button v-b-tooltip.hover.top="'Adicionar Carona'"
                                v-if="data.item.permiteCarona == 1 && data.item.idOrgaoGerenciador != departamento"
                                class="my-2 mx-1" size="sm" pill variant="primary" @click="abrirCarona(data.item)">
                                <b-icon icon="cart-plus" />
                            </b-button>

                            <b-button class="my-2 mx-1" size="sm" pill variant="primary" @click="visualizar(data.item)">
                                <b-icon v-b-tooltip.hover.top="'Visualizar'" icon="eye" />
                            </b-button>

                        </b-row>
                    </template>
                </b-table>

                <b-row style="margin-top: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>

            </b-card>

            <ConsultarAtasForm :processoCompra="processoCompra" v-if="modalNovaAta" :prefix="prefix + title + ' > '"
                :idAta="selectedAtaId" :isViewMode="isViewMode" @close='fecharModalNovaAta' />

            <ModalConsultarCarona :prefix="prefix + title + ' > '" @close="fecharCarona" :ata="selectedAtaId"
                v-if="mostrarCarona">
            </ModalConsultarCarona>
        </b-card-body>

        <LgFinderPageConsultarRequisicoesCompra @input="fecharRequisicoes" :ata="selectedAtaId"
            :prefix="prefix + title + ' > '" v-if="mostrarRequisicoes" :isModal="true">
        </LgFinderPageConsultarRequisicoesCompra>

        <ModalConsultarSolicitacaoAlteracaoValor :prefix="prefix + title + ' > '"
            @close="fecharModalConsultarSolicitacaoAlteracaoValor" :ata="selectedAtaId"
            v-if="mostrarModalConsultarSolicitacaoAlteracaoValor">
        </ModalConsultarSolicitacaoAlteracaoValor>
    </b-card>
</template>

<script>
import ConsultarAtasForm from "./ConsultarAtasForm.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ResourceService from "@/core/api/ResourceService"
import { ListResourceMixin } from "@/core/mixins/resource";
import { getContext } from "@/core/auth"
import ModalConsultarCarona from "./ModalConsultarCarona.vue"
import LgFinderPageConsultarRequisicoesCompra from "@/components/Finders/LgFinderPageConsultarRequisicoesCompra.vue"
import ModalConsultarSolicitacaoAlteracaoValor from "./ModalConsultarSolicitacaoAlteracaoValor.vue";
import LgFinderPageEmpresa from "@/components/Finders/LgFinderPageEmpresa.vue";
import LgFinderPageProduto from "@/components/Finders/LgFinderPageProduto.vue";
import LgFinderPageStatus from "@/components/Finders/LgFinderPageStatus.vue";

export default {
    components: {
        LgFinderPageStatus,
        LgFinderPageProduto,
        LgFinderPageEmpresa,
        ModalConsultarCarona,
        ConsultarAtasForm,
        LgFormInput,
        LgFinderPageConsultarRequisicoesCompra,
        ModalConsultarSolicitacaoAlteracaoValor
    },
    mixins: [ListResourceMixin],
    props: {
        processoCompra: {
            type: Object,
            default: null
        },

        prefix: {
            type: String,
            default: ""
        }
    },
    name: "ConsultarAta",
    data() {
        return {
            produto: {},
            empresa: {},
            status: {},
            mostrarModalConsultarSolicitacaoAlteracaoValor: false,
            mostrarRequisicoes: false,
            modalNovaAta: false,
            mostrarCarona: false,
            departamento: getContext().departamento.id,
            pesquisa: "",
            title: "Consultar Atas",
            selectedAtaId: null,
            fields: [
                { key: "numeroAta", label: "Nº de Ata" },
                { key: "dataAssinatura", label: "Data Assinatura" },
                { key: "dataInicial", label: "Vigência" },
                { key: "orgaoGerenciador", label: "Orgão Gerenciador" },
                { key: "status", label: "Status" },
                { key: "actions", label: "" },
            ],

            busy: false,
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],

            isViewMode: false,
        }
    },
    watch: {
        page() {
            this.load();
        },
    },

    beforeMount() {
        this.$service = new ResourceService("/api/atas");
        this.load()
    },
    methods: {
        handleEmpresa(item) {
            this.empresa = item;
            this.load();

        },
        handleStatus(item) {
            this.status = item;
            this.load();

        },
        handleProduto(item) {
            this.produto = item;
            this.load();
        },
        fecharModalConsultarSolicitacaoAlteracaoValor() {
            this.mostrarModalConsultarSolicitacaoAlteracaoValor = null,
                this.selectedAtaId = null;
        },

        abrirModalConsultarSolicitacaoAlteracaoValor(item) {
            this.selectedAtaId = item.id;
            this.mostrarModalConsultarSolicitacaoAlteracaoValor = true;
        },
        abrirRequisicoes(item) {
            this.selectedAtaId = item.id;
            this.mostrarRequisicoes = true;
        },
        fecharRequisicoes() {
            this.mostrarRequisicoes = false;
            this.selectedAtaId = null;

        },
        fecharCarona() {
            this.mostrarCarona = false;
            this.selectedAtaId = null;
        },
        abrirCarona(ata) {
            this.selectedAtaId = ata.id

            this.mostrarCarona = true;

        },
        clickRow(item) {
            this.$emit("close", item);
        },
        async load() {
            this.busy = true

            this.filtro = {};

            if (this.empresa && this.empresa.id)
                this.filtro.empresa = this.empresa.id;

            if (this.status && this.status.id)
                this.filtro.status = this.status.id;

            if (this.produto && this.produto.id)
                this.filtro.produto = this.produto.id;

            if (this.pesquisa && this.pesquisa != "")
                this.filtro.pesquisa = this.pesquisa;

            if (this.processoCompra && this.processoCompra.id)
                this.filtro.processoCompra = this.processoCompra.id;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,

            });
        },
        showModalNovaAta() {
            this.modalNovaAta = true;
        },
        fecharModalNovaAta() {
            this.modalNovaAta = false;
            this.selectedAtaId = null
            this.isViewMode = false
            this.load()
        },
        visualizar(ata) {
            this.selectedAtaId = ata.id
            this.isViewMode = true
            this.modalNovaAta = true;
        },
        formatDate(dateString) {
            if (!dateString) return "N/A";

            const [datePart] = dateString.split("T");
            const [year, month, day] = datePart.split("-");

            return `${day}/${month}/${year}`;
        },
        formatSituacao(situacao) {
            const situacoes = {
                270: "Vigente",
                271: "Expirado",
                272: "Não iniciado",
            }
            return situacoes[situacao] || "N/A"
        },
        badgeVariant(situacao) {
            const variants = {
                270: "success",
                272: "warning",
            }
            return variants[situacao] || "secondary"
        },
        isVigente(situacao) {
            return situacao === 270
        },
        clearForm() {
            this.pesquisa = ''
            this.produto = {};
            this.empresa = {};
            this.status = {};
            this.load()
        },
    },
}
</script>

<style scoped>
.badge {
    font-size: 85% !important;
    padding: 5px 10px !important;
}

.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>